import WeBelieve, { WeBelieveProps } from "./WeBelieve";

export { WeBelieve, WeBelieveProps };

export default WeBelieve;
